<template>
  <div class="container">

    <BaseMarkdownEditor v-model="valueModel" class="editor"
      :placeholder="$t('folder.records.createAndEditModal.messagePlaceHolder')" :with-link="false"
      :error-messages="descriptionErrors" />

    <div class="preview">
      <div id="preview-toolbar" class="preview-toolbar">
        <BaseButton id="variables-menu-activator" icon="$mdiCodeBraces" size="24" :disabled="variables.length <= 0">Ajouter un champ</BaseButton>

        <v-menu activator="#variables-menu-activator">
          <v-list>
            <v-list-item v-for="(variable, index) in variables" :key="index" :value="variable.value"
              @click="addVariable(variable)">
              <v-list-item-title>{{ variable.key }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <vue-editor class="preview-editor" :value="previewValue" :editor-options="previewEditorOptions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseMarkdownPreview",
  model: {
    prop: "value",
    event: "updateValue",
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    variables: {
      type: Array,
      default: null,
    },
    descriptionErrors: {
      type: Array,
      default: null,
    },
  },
  computed: {
    valueModel: {
      set: function (value) {
        this.$emit("updateValue", value);
      },
      get: function () {
        return this.value;
      },
    },
    previewValue() {
      if (!this.value) {
        return this.$t("folder.records.createAndEditModal.previewMessagePlaceHolder");
      }

      return this.value?.replaceAll(/{{\s*([^}]+)\s*}}/g, (match, p1) => {
        const variableName = p1.trim();
        const variables = this.variables.filter((variable) => variable.key === variableName);
        if (variables.length <= 0) {
          return "";
        };

        const variable = variables[0];
        if (variable.type === "DATE") {
          return (new Date(variable.value)).toLocaleDateString();
        } else if (variable.type === "DATETIME") {
          return (new Date(variable.value)).toLocaleString();
        } else if (
          variable.type === "MESSAGE" ||
          variable.type === "NUMBER" ||
          variable.type === "TEXT" ||
          variable.type === "TEXTAREA"
        ) {
          return variables[0].value;
        }

        return "";
      }) ?? "";
    },
    previewEditorOptions() {
      return {
        readOnly: true,
        modules: {
          toolbar: false,
        },
      };
    },
  },
  methods: {
    addVariable(variable) {
      this.valueModel = (this.value + "{{" + variable.key + "}}");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
}

.editor {
  flex-grow: 1;
}

.preview {
  width: 40%;

  ::v-deep .focused {
    outline: 1px solid #2536cc;
    box-shadow: 0px 0px 12px 4px #ebf2ff;
    border-radius: 5px;
    overflow: hidden;
  }

  .preview-toolbar {
    height: 48px;

    display: flex;
    flex-direction: row;
    padding: 8px 4px;

    border: 1px solid #ccc;
    border-bottom: none;
  }

  .preview-editor {
    border: none;
  }

  .ql-toolbar {
    display: none;
  }
}
</style>
